export default __webpack_public_path__ + "static/rollup-0fcb0858eb9418dd9774985241c30a4d.jpg";